// extracted by mini-css-extract-plugin
export default {"typeSelector":"style_typeSelector__WqXZp","button":"style_button__-xrLS","active":"style_active__sc2Er"};